import BaseAction from "base/base.action";
import { FaqType } from "domain/types/faq.type";
import { FaqResponse } from "model/faq/faq.response";
import { FaqRequestParams, FaqInsertRequest, FaqUpdateRequest } from "model/faq/faq.request";

/**
 * Action to request FAQs from API
 * @param params Request parameters
 * @returns Action object
 */
export const fetchFaqsRequestAction = (params: FaqRequestParams) => {
  return BaseAction(FaqType.FETCH_FAQS_REQUEST, { params });
};

/**
 * Action for successful FAQs fetch
 * @param response FAQ response data
 * @returns Action object
 */
export const fetchFaqsSuccessAction = (response: FaqResponse) => {
  return BaseAction(FaqType.FETCH_FAQS_SUCCESS, { 
    faqs: response.all_faqs
  });
};

/**
 * Action for failed FAQs fetch
 * @param error Error message
 * @returns Action object
 */
export const fetchFaqsFailureAction = (error: string) => {
  return BaseAction(FaqType.FETCH_FAQS_FAILURE, { error });
};

export const insertFaqRequestAction = (params: FaqInsertRequest) => {
  return BaseAction(FaqType.INSERT_FAQ_REQUEST, { params });
};

export const insertFaqSuccessAction = (response: any) => {
  return BaseAction(FaqType.INSERT_FAQ_SUCCESS, { response });
};

export const insertFaqFailureAction = (error: string) => {
  return BaseAction(FaqType.INSERT_FAQ_FAILURE, { error });
};

export const updateFaqRequestAction = (params: FaqUpdateRequest) => {
  return BaseAction(FaqType.UPDATE_FAQ_REQUEST, { params });
};

export const updateFaqSuccessAction = (response: any) => {
  return BaseAction(FaqType.UPDATE_FAQ_SUCCESS, { response });
};

export const updateFaqFailureAction = (error: string) => {
  return BaseAction(FaqType.UPDATE_FAQ_FAILURE, { error });
};